const Whatsapp = () => {
    return (
        <svg
            width="104"
            height="104"
            viewBox="0 0 104 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.75" filter="url(#filter0_d_1200_98156)">
                <circle cx="52" cy="50" r="40" fill="#211C45" />
                <path
                    d="M42.506 62.988L43.954 63.834C46.3959 65.2581 49.1732 66.0058 52 66C55.1645 66 58.2579 65.0616 60.8891 63.3035C63.5203 61.5454 65.5711 59.0465 66.7821 56.1229C67.9931 53.1993 68.3099 49.9822 67.6926 46.8785C67.0752 43.7748 65.5514 40.9239 63.3137 38.6863C61.0761 36.4486 58.2252 34.9248 55.1215 34.3074C52.0178 33.6901 48.8007 34.0069 45.8771 35.2179C42.9535 36.4289 40.4546 38.4797 38.6965 41.1109C36.9384 43.7421 36 46.8355 36 50C36 52.872 36.754 55.626 38.168 58.048L39.012 59.496L37.706 64.298L42.506 62.988ZM32.008 70L34.712 60.064C32.9303 57.0097 31.9942 53.536 32 50C32 38.954 40.954 30 52 30C63.046 30 72 38.954 72 50C72 61.046 63.046 70 52 70C48.4656 70.0057 44.9933 69.0703 41.94 67.29L32.008 70ZM44.782 40.616C45.05 40.596 45.32 40.596 45.588 40.608C45.696 40.616 45.804 40.628 45.912 40.64C46.23 40.676 46.58 40.87 46.698 41.138C47.294 42.49 47.874 43.852 48.434 45.218C48.558 45.522 48.484 45.912 48.248 46.292C48.0857 46.5489 47.9101 46.7973 47.722 47.036C47.496 47.326 47.01 47.858 47.01 47.858C47.01 47.858 46.812 48.094 46.888 48.388C46.916 48.5 47.008 48.662 47.092 48.798L47.21 48.988C47.722 49.842 48.41 50.708 49.25 51.524C49.49 51.756 49.724 51.994 49.976 52.216C50.912 53.042 51.972 53.716 53.116 54.216L53.126 54.22C53.296 54.294 53.382 54.334 53.63 54.44C53.754 54.492 53.882 54.538 54.012 54.572C54.1464 54.6062 54.2878 54.5998 54.4185 54.5535C54.5492 54.5072 54.6632 54.4231 54.746 54.312C56.194 52.558 56.326 52.444 56.338 52.444V52.448C56.4386 52.3542 56.5581 52.2829 56.6885 52.2391C56.8189 52.1953 56.9572 52.1799 57.094 52.194C57.214 52.202 57.336 52.224 57.448 52.274C58.51 52.76 60.248 53.518 60.248 53.518L61.412 54.04C61.608 54.134 61.786 54.356 61.792 54.57C61.8 54.704 61.812 54.92 61.766 55.316C61.702 55.834 61.546 56.456 61.39 56.782C61.2832 57.0045 61.1414 57.2084 60.97 57.386C60.7682 57.5979 60.5473 57.7907 60.31 57.962C60.2279 58.0237 60.1446 58.0837 60.06 58.142C59.8113 58.2998 59.5557 58.4466 59.294 58.582C58.7791 58.8555 58.2103 59.0125 57.628 59.042C57.258 59.062 56.888 59.09 56.516 59.07C56.5 59.07 55.38 58.896 55.38 58.896C52.5365 58.1481 49.9068 56.7469 47.7 54.804C47.248 54.406 46.83 53.978 46.402 53.552C44.622 51.782 43.278 49.872 42.462 48.068C42.0444 47.1826 41.8188 46.2188 41.8 45.24C41.7918 44.0257 42.1887 42.8433 42.928 41.88C43.074 41.692 43.212 41.496 43.45 41.27C43.704 41.03 43.864 40.902 44.038 40.814C44.2694 40.6981 44.5217 40.63 44.78 40.614L44.782 40.616Z"
                    fill="#F0F0FA"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1200_98156"
                    x="0"
                    y="0"
                    width="104"
                    height="104"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.057 0 0 0 0 0.057 0 0 0 0 0.158333 0 0 0 0.33 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1200_98156"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1200_98156"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export default Whatsapp;
